import React from "react";
import { Route, Routes } from "react-router-dom";

import { RecaptchaProvider } from "@/components/providers/RecaptchaProvider";
import { AuthProvider } from "@/contexts/auth-context";
import { LanguageProvider } from "@/contexts/language-context";
import { NotificationProvider } from "@/contexts/notification-context";
import { ToastProvider } from "@/contexts/toast-context";
import Campaigns from "@/pages/Campaigns";
import Company from "@/pages/Company";
import Contacts from "@/pages/Contacts";
import CoverageArea from "@/pages/CoverageArea";
import ConversationReport from "@/pages/ConversationReport";
import CustomerService from "@/pages/CustomerService";
import ServiceQueue from "@/pages/ServiceQueue";
import Subject from "@/pages/Subject";
import Dashboard from "@/pages/Dashboard";
import EmailConfirmation from "@/pages/EmailConfirmation";
import EmailValidation from "@/pages/EmailValidation";
import Home from "@/pages/Home";
import Imports from "@/pages/Imports";
import ListPrice from "@/pages/ListPrice";
import Login from "@/pages/Login";
import LoginImpersonation from "@/pages/LoginImpersonation";
import NotFound from "@/pages/NotFound";
import Notifications from "@/pages/Notifications";
import Orders from "@/pages/Orders";
import Plans from "@/pages/Plans";
import MessageTemplates from "@/pages/MessageTemplates";
import Platforms from "@/pages/Platforms";
import Privacy from "@/pages/Privacy";
import ProductCategories from "@/pages/ProductCategories";
import Products from "@/pages/Products";
import ProductVariations from "@/pages/ProductVariations";
import Profile from "@/pages/Profile";
import ProfileChangePassword from "@/pages/ProfileChangePassword";
import ProfileChangePasswordExpired from "@/pages/ProfileChangePasswordExpired";
import ProfilePermissions from "@/pages/ProfilePermissions";
import RecoverPassword from "@/pages/RecoverPassword";
import Register from "@/pages/Register";
import Renew from "@/pages/Renew";
import Sku from "@/pages/Sku";
import Subscribe from "@/pages/Subscribe";
import Terms from "@/pages/Terms";
import Users from "@/pages/Users";
import Integrations from "@/pages/Integrations";
import Workflow from "@/pages/Workflow";
import AppSplashScreen from "@/components/organisms/AppSplashScreen";
import LoadingProvider from "@/providers/loading-provider";
import LocalizationProvider from "@/providers/localization-provider";
import StyleProviders from "@/providers/style-providers";

function App() {
  return (
    <div>
      <AppSplashScreen />
      <StyleProviders>
        <LoadingProvider>
          <LanguageProvider>
            <LocalizationProvider>
              <ToastProvider>
                <RecaptchaProvider>
                  <AuthProvider>
                    <NotificationProvider>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/:lang" element={<Home />} />
                        <Route path="/login/:lang?" element={<Login />} />
                        <Route path="/login/impersonation/:token/:lang?" element={<LoginImpersonation />} />
                        <Route
                          path="/login/recover-password/:lang?"
                          element={<RecoverPassword />}
                        />
                        <Route path="/register/:lang?" element={<Register />} />
                        <Route
                          path="/profile/change-password-expired/:isPasswordExpired/:lang?"
                          element={<ProfileChangePasswordExpired />}
                        />
                        <Route
                          path="/profile/change-password/:lang?"
                          element={<ProfileChangePassword />}
                        />
                        <Route
                          path="/profile/permissions/:lang?"
                          element={<ProfilePermissions />}
                        />
                        <Route path="/profile/:lang?" element={<Profile />} />

                        {/* Dashboard Routes */}
                        <Route path="/dashboard/*" element={<Dashboard />} />

                        {/* Catalog Routes */}
                        <Route path="/catalog/products/*" element={<Products />} />
                        <Route
                          path="/catalog/productCategories/*"
                          element={<ProductCategories />}
                        />
                        <Route
                          path="/catalog/productVariations/*"
                          element={<ProductVariations />}
                        />

                        {/* SKU Routes */}
                        <Route path="/sku/*" element={<Sku />} />

                        {/* Orders Routes */}
                        <Route path="/orders/orders/*" element={<Orders />} />

                        {/* Customer Service Routes */}
                        <Route path="/customerService/contacts/*" element={<Contacts />} />
                        <Route path="/customerService/chat/*" element={<CustomerService />} />
                        <Route
                          path="/customerService/conversations/*"
                          element={<ConversationReport />}
                        />

                        {/* Pricing Routes */}
                        <Route path="/pricing/campaigns/*" element={<Campaigns />} />
                        <Route path="/pricing/listPrice/*" element={<ListPrice />} />

                        {/* Campaign Statistics Routes (mantidos sob /pricing/campaigns) */}

                        {/* Settings Routes */}
                        <Route path="/settings/company/*" element={<Company />} />
                        <Route path="/settings/platforms/*" element={<Platforms />} />
                        <Route path="/settings/templates/*" element={<MessageTemplates />} />
                        <Route path="/settings/coverage-area/*" element={<CoverageArea />} />
                        <Route path="/settings/service-queue/*" element={<ServiceQueue />} />
                        <Route path="/settings/subjects/*" element={<Subject />} />
                        <Route path="/settings/workflow/*" element={<Workflow />} />
                        <Route path="/settings/users/*" element={<Users />} />
                        <Route path="/settings/integrations/*" element={<Integrations />} />

                        {/* App Specific Routes */}
                        <Route path="/terms/:lang?" element={<Terms />} />
                        <Route path="/privacy/:lang?" element={<Privacy />} />
                        <Route path="/plans/:lang?/*" element={<Plans />} />
                        <Route path="/notifications/:lang?/*" element={<Notifications />} />
                        <Route path="/emailValidation/:lang?" element={<EmailValidation />} />
                        <Route
                          path="/emailConfirmation/:token/:lang?"
                          element={<EmailConfirmation />}
                        />
                        <Route path="/imports/*" element={<Imports />} />
                        <Route path="/subscribe/*" element={<Subscribe />} />
                        <Route path="/renew/*" element={<Renew />} />

                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </NotificationProvider>
                  </AuthProvider>
                </RecaptchaProvider>
              </ToastProvider>
            </LocalizationProvider>
          </LanguageProvider>
        </LoadingProvider>
      </StyleProviders>
    </div>
  );
}

export default App;
